


import { DATA_TABLE_STYLE_TYPE } from '../../../../common/constants/dataTableStyleType';

export const isDataTableExpanderHeightAvailable = (
styleType) =>
styleType === DATA_TABLE_STYLE_TYPE.SECONDARY;